module.exports = __webpack_public_path__ + "static/media/costInGeneral.90705166.mp3";